// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';
import { occupancies } from '#constants/occupancies.js';

const items = occupancies.map(occupancy => ({
  id: occupancy.occupancyId,
  value: occupancy.occupancyId,
  name: occupancy.occupancy,
}));

type Props = {
  form: string,
  name: string,
};

const OccupancySelectMenu = ({ form, name }: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    name={name}
    id={name}
    items={items}
    className={classNames('custom-select', 'occupancy-select')}
  />
);

export default OccupancySelectMenu;
